let yx_prefix = ''
let api = {
    //nfc
    GLOBAL_verify_nfc_findVerifyList: yx_prefix + "/verify/nfc/findVerifyList",
    GLOBAL_verify_nfc_findVerifyAndUnVerifyCount: yx_prefix + "/verify/nfc/findVerifyAndUnVerifyCount",
    GLOBAL_device_config_findVerifyAndUnVerifyCount: yx_prefix + "/device/config/findVerifyAndUnVerifyCount",
    GLOBAL_device_signet_verifySwitch: yx_prefix + "/device/signet/verifySwitch",//开启或关闭NFC核验
    GLOBAL_verify_nfc_intervene: yx_prefix + "/verify/nfc/intervene",//人工干预
    GLOBAL_verify_nfc_verificationCertificate: yx_prefix + "/verify/nfc/verificationCertificate",//核验证书
    GLOBAL_verify_nfc_auditList: yx_prefix + "/verify/nfc/auditList",//芯片绑定审核列表
    GLOBAL_verify_nfc_auditAgree: yx_prefix + "/verify/nfc/auditAgree",//审核通过
    GLOBAL_verify_nfc_verifyFailList: yx_prefix + "/verify/nfc/verifyFailList",//核验失败列表

    //批量绑定申请单
    GLOBAL_application_application_getSimpleApplication: yx_prefix + "/application/application/getSimpleApplication",//申请单
    GLOBAL_device_sealRecordInfo_batchBanding: yx_prefix + "/device/sealRecordInfo/batchBanding",//批量绑定


    //文件流下载
    GLOBAL_file_fileInfo_downloadNoneNeedAccess: yx_prefix + "/file/fileInfo/downloadNoneNeedAccess", //{fileInfoId}
    //首页
    GLOBAL_blockchain_dashboard_ratioData: yx_prefix + "/hubei/blockchain/dashboard/ratioData", //环比
    GLOBAL_blockchain_dashboard_pointData: yx_prefix + "/hubei/blockchain/dashboard/pointData", //环比
    GLOBAL_blockchain_dashboard_statistics: yx_prefix + "/hubei/blockchain/dashboard/statistics",
    GLOBAL_blockchain_deviceData_typeList: yx_prefix + "/hubei/blockchain/deviceData/typeList",
    GLOBAL_blockchain_dashboard_add: yx_prefix + "/hubei/blockchain/dashboard/add", //创建申请单
    GLOBAL_chain_findByOuterId: yx_prefix + "/hubei/blockchain/proxy/findByOuterId", //区块链
    GLOBAL_chain_findByApplicationId: yx_prefix + "/hubei/blockchain/proxy/findByApplicationId", //区块链d

    GLOBAL_gkQss_transCryption1: yx_prefix + "/gkQss/transCryption1", //转加密秘钥
    //权限路由
    GLOBAL_electronic_bank_findButtonList: yx_prefix + "/electronic/bank/findButtonList", //查询按钮的路由编码列表

    GLOBAL_ENV: process.env.NODE_ENV === "development",
    GLOBAL_HOST: window.location.href.match(/((.*?)\/\/(.*?))\//)[1],
    GLOBAL_HOST_IMAGE: process.env.NODE_ENV === "development" ?
        "https://test.qstamper.com:8036" :
        window.location.href.match(/((.*?)\/\/(.*?))\//)[1],
    GLOBAL_crptorgraphy: yx_prefix + "/crptorgraphy", //量子加密
    GLOBAL_decrpy: yx_prefix + "/decrpy", //量解密

    GLOBAL_perms_getRoute: yx_prefix + "/auth/perms/getRoute", //动态菜单
    GLOBAL_signet_unlock: yx_prefix + "/device/signet/unlock", //手动解锁
    GLOBAL_device_signet_queryLocation: yx_prefix + "/device/signet/queryLocation", //获取地图印章位置
    GLOBAL_auth_appRotationImg_add: yx_prefix + "/auth/appRotationImg/add", //增加轮播图
    GLOBAL_auth_appRotationImg_getAll: yx_prefix + "/auth/appRotationImg/getAll", //查询已配置的轮播图列表
    GLOBAL_auth_appRotationImg_del: yx_prefix + "/auth/appRotationImg/del", //删除轮播图
    GLOBAL_auth_user_isDirector: yx_prefix + "/auth/user/isDirector", //获取用户权限
    GLOBAL_key_randomPubKey: yx_prefix + "/key/randomPubKey", //获取rsa公钥
    GLOBAL_file_fileInfo_checkFilesize: yx_prefix + "/file/fileInfo/checkFilesize", //上传判断文件大小
    GLOBAL_file_fileInfo_quantumCryptographyPretreatment: "/file/fileInfo/quantumCryptographyPretreatment", //明文加密
    GLOBAL_personal_center_edit: "/personal/center/edit", //修改个人信息

    /**
     * OCR服务相关
     */
    GLOBAL_ocr_create_client: "/proxy/ocr/ocrClient/create", // 创建OCR客户端
    GLOBAL_ocr_delete_client: "/proxy/ocr/ocrClient/delete", // 删除OCR客户端
    GLOBAL_ocr_edit_client: "/proxy/ocr/ocrClient/edit", // 编辑OCR客户端
    GLOBAL_ocr_client_list: "/proxy/ocr/ocrClient/findList", // 查询OCR客户端列表
    GLOBAL_ocr_tenant_list: "/proxy/ocr/ocrTenant/findList", // 查询OCR客户端的租户列表
    GLOBAL_ocr_edit_tenant: "/proxy/ocr/ocrTenant/edit", // 编辑租户信息
    GLOBAL_ocr_compare_result: "/ocr/ocrResult/findCompareResult", // 查询申请单的使用记录文本相似度对比结果
    GLOBAL_ocr_result_post: "/ocrCompareApprove/handleOcrCompare", // OCR提交审核
    GLOBAL_ocr_threshold_find: "/deviceThreshold/findOcrThreshold", // OCR告警值查询
    GLOBAL_ocr_edit_threshold: "/deviceThreshold/editByDevice", // OCR告警值更新
    GLOBAL_application_ocr_handlerErrorOcrApplication: "/application/ocr/handlerErrorOcrApplication", // 处理申请单（比对结果小于阈值）

    /**
     * 缴费服务相关
     */
    GLOBAL_payment_list: "/proxy/bbc/payment/findList", // 查询缴费机构配置列表
    GLOBAL_payment_create: "/proxy/bbc/payment/create", // 创建缴费机构配置信息
    GLOBAL_payment_update: "/proxy/bbc/payment/edit", // 更新缴费机构配置信息
    GLOBAL_payment_available_code: "/proxy/bbc/payment/findAvailablePaymentCode/", // 查询缴费机构配置列表
    GLOBAL_payment_business_list: "/proxy/bbc/domain/list", // 查询系统中所有业务服务器配置列表
    GLOBAL_payment_find_list: "/proxy/bbc/payment/findList",
    GLOBAL_payment_info: "/proxy/bbc/payment/findByUuid", // 查询设备缴费配置详情列表
    GLOBAL_exchange_tokens: "/bbc/exchangeTokens", // 设备换卡
    /**
     * 设备配置相关
     */
    GLOBAL_organization_list: "/device/config/findOrganizationList", // 查询系统中所有组织列表
    GLOBAL_organization_root_list: "/device/config/findDepartmentRootList", // 查询系统中所有组织的根机构列表
    GLOBAL_migration_change_device: "/device/config/migrationTenant", // 设备换卡
    GLOBAL_update_device: "/device/config/updateDevice",
    /**
     * 申请单相关
     */
    GLOBAL_application_list: "/application/application/findApplicationList",
    /**
     * 日志相关
     */
    GLOBAL_log_logger_list: "/proxy/logger/operation/logger/queryCondition", // 日志列表
    GLOBAL_log_logger_object_list: "/proxy/logger/operation/loggerObject/findList", // 日志列表

    //职称相关
    GLOBAL_auth_position_getAllPositionList: yx_prefix + "/auth/position/getAllPositionList", //查询职称列表
    GLOBAL_auth_position_delPosition: yx_prefix + "/auth/position/delPosition", //删除职称
    GLOBAL_auth_position_addPosition: yx_prefix + "/auth/position/addPosition", //添加职称
    //使用记录
    GLOBAL_device_seal_record_info_getInfoByApplicationId: yx_prefix +
        "/device/sealRecordInfo/getInfoByApplicationId", //查询申请单使用记录
    //组织相关
    GLOBAL_auth_org_getOrgsByPhone: yx_prefix + "/auth/org/getOrgsByPhone", //获取指定手机号所在的公司列表
    GLOBAL_auth_org_getOrgTree: yx_prefix + "/auth/org/getOrgTree", //查询登录用户组织树
    GLOBAL_auth_org_getOrganizationalTreeNode: yx_prefix + "/auth/org/getOrganizationalTreeNode", //查询组织架构树节点信息
    GLOBAL_auth_department_getDepartmentsByLogin: yx_prefix + "/auth/department/getDepartmentsByLogin", //查询用户所属组织列表
    //员工相关
    GLOBAL_auth_user_getEmployeeForManagerByDepartmentId: yx_prefix +
        "/auth/user/getEmployeeForManagerByDepartmentId", //查询可作为集团(企业、部门)负责人的员工列表
    GLOBAL_auth_user_addEmployee: yx_prefix + "/auth/user/addEmployee", //添加员工
    GLOBAL_auth_user_changeOrg: yx_prefix + "/auth/user/changeOrg", //切换组织
    //公司部门相关
    GLOBAL_auth_department_getLevelsByOrgForAddAndUpdateEmployee: yx_prefix +
        "/auth/department/getLevelsByOrgForAddAndUpdateEmployee", //查询织架构(级联形式)用于添加(更新)员工信息
    GLOBAL_auth_department_getParents: yx_prefix + "/auth/department/getParents", //查询可作为企业(部门)父组织的组织列表
    GLOBAL_auth_org_getOrgsByLogin: yx_prefix + "/auth/org/getOrgsByLogin", //查询登录用户拥有的集团列表
    GLOBAL_auth_org_regV2: yx_prefix + "/auth/org/regV2", //注册组织
    GLOBAL_auth_department_getLevelsByOrgForAddAndUpdateFlow: yx_prefix +
        "/auth/department/getLevelsByOrgForAddAndUpdateFlow",

    GLOBAL_auth_department_addDepartment: yx_prefix + "/auth/department/addDepartment", //添加企业、团队、组织
    GLOBAL_auth_department_delDepartment: yx_prefix + "/auth/department/delDepartment", //删除企业、团队、组织
    GLOBAL_auth_department_updateDepartment: yx_prefix + "/auth/department/updateDepartment", //修改企业、团队、组织
    GLOBAL_find_platform_organizations: "/auth/department/findPlatformOrganizations", // 查询平台中所有租户组织机构树数据
    GLOBAL_auth_notice_getDisassemblyRecordInfoList: yx_prefix +
        "/auth/notice/getDisassemblyRecordInfoList", //拉取设备拆卸通知弹出消息列表

    //配置管理
    GLOBAL_device_userConfig_getList: yx_prefix + "/device/userConfig/getList", //查询本公司所有印章配置列表
    GLOBAL_device_userConfig_updateConfig: yx_prefix + "/device/userConfig/updateConfig", //修改配置信息
    GLOBAL_device_finger_searchFingers: yx_prefix + "/device/finger/searchFingers", //查询用户拥有的指纹列表

    //印章监控系统
    GLOBAL_device_detail_searchSignetDetailList: yx_prefix + "/device/detail/searchSignetDetailList", //设备概况
    GLOBAL_device_detail_searchAddrDetails: yx_prefix + "/device/detail/searchAddrDetails", //印章运动轨迹
    GLOBAL_device_detail_searchDeviceDetails: yx_prefix + "/device/detail/searchDeviceDetails", //查询设备操作日志
    GLOBAL_device_detail_getCmds: yx_prefix + "/device/detail/getCmds", //查询指令码列表接口
    GLOBAL_device_disassemblyRecordInfo_getInfoByNoticeId: yx_prefix +
        "/device/disassemblyRecordInfo/getInfoByNoticeId", //查看(设备拆卸)系统消息详情
    GLOBAL_device_sealRecordInfo_blankOutInfo: yx_prefix + "/device/sealRecordInfo/customRemark", //使用记录作废

    GLOBAL_loginURI: yx_prefix + "/auth/user/loginV1", //登录接口（密码登录）
    GLOBAL_user_loginV2: yx_prefix + "/auth/user/loginV2", //登录接口（手机号登录）
    GLOBAL_getPhoneCode: yx_prefix + "/auth/user/getPhoneCode", //获取手机验证码
    GLOBAL_LOGIN_GIF: yx_prefix + "/auth/user/getGifCode", //动态码
    GLOBAL_user_logout: yx_prefix + "/auth/user/logout", //用户登出
    GLOBAL_user_getShortcutAll: yx_prefix + "/auth/user/getShortcutAll", //获取全部快捷方式
    GLOBAL_user_getShortcuts: yx_prefix + "/auth/user/getShortcuts", //获取用户已经设置的快捷方式
    GLOBAL_user_updateShortcut: yx_prefix + "/auth/user/updateShortcut", //更新设置的快捷方式

    //我的面板
    GLOBAL_myuserInfo: yx_prefix + "/auth/user/get", //获取用户信息
    GLOBAL_myuserUpdate: yx_prefix + "/auth/user/myUpdate", //修改用户资料
    GLOBAL_user_changePasswordV1: yx_prefix + "/auth/user/changePasswordV1", //修改密码
    GLOBAL_personalNotices: yx_prefix + "/auth/notice/getNoticesByUser", //系统消息
    GLOBAL_resetPassword: yx_prefix + "/auth/user/resetPwd", //重置密码
    GLOBAL_application_getByOwnerApplications: yx_prefix + "/application/application/getByOwnerApplications", //我的申请
    GLOBAL_application_getByMyApplication: yx_prefix + "/application/application/getByMyApplication", //查询申请单详情
    GLOBAL_application_cancelApplication: yx_prefix + "/application/application/cancelApplication", //取消申请单
    GLOBAL_application_exitApplication: yx_prefix + "/application/application/exitApplication", //结束用章

    //查看当前系统消息
    GLOBAL_ckeckNotice: yx_prefix + "/auth/notice/checkNoticeV2", //点击查看当前系统消息
    //平台管理
    GLOBAL_permsadd: yx_prefix + "/auth/perms/add", //添加权限
    GLOBAL_perms_update: yx_prefix + "/auth/perms/update", //编辑
    GLOBAL_getTree: yx_prefix + "/auth/perms/getTree", //权限树
    GLOBAL_permsgetAll: yx_prefix + "/auth/perms/getAll", //获取所有权限
    GLOBAL_permsgetdel: yx_prefix + "/auth/perms/del", //删除节点权限
    GLOBAL_flow_add: yx_prefix + "/application/flow/add", //添加审批流程
    GLOBAL_device_cameraSwitch: yx_prefix + "/device/signet/cameraSwitch", //摄像头开启关闭
    GLOBAL_device_witch_high_profile_camera: "/device/signet/switchHighProfileCamera", //高拍仪开启关闭
    GLOBAL_device_signet_switchTextRecognition: "/device/signet/switchTextRecognition", //切换设备文字识别

    /**
     * 钉钉设备相关
     */
    GLOBAL_device_updateDeviceAutoLockSeconds: yx_prefix +
        "/device/dingSignet/updateDeviceAutoLockSeconds", // 更新设备上锁时间

    /**
     * 插件配置相关
     */
    GLOBAL_plugin_list: yx_prefix + "/plugin/findList", // 插件列表
    GLOBAL_plugin_type_list: yx_prefix + "/plugin/findTypeList", // 插件类型列表
    GLOBAL_plugin_insert: yx_prefix + "/plugin/create", // 新增插件
    GLOBAL_plugin_edit: yx_prefix + "/plugin/edit", // 编辑插件
    GLOBAL_plugin_delete: yx_prefix + "/plugin/remove/", // 编辑插件

    /**
     * 系统默认角色列表
     */
    GLOBAL_system_default_role_temp_list: "/auth/roleTemp/systemRoleTemplatesList", // 系统默认角色列表
    GLOBAL_system_default_update: "/auth/roleTemp/updateRoleTemp", // 更新系统默认角色模板
    GLOBAL_system_default_delete: "/auth/roleTemp/deleteRoleTemp", // 删除系统默认角色模板
    GLOBAL_system_default_insert: "/auth/roleTemp/insertRoleTemp", // 新增系统默认角色模板
    GLOBAL_system_default_detail: "/auth/roleTemp/roleTemplateInformationForDetails", // 系统角色模板详情信息
    GLOBAL_system_default_updateSystemRolePermissionsTemplate: "/auth/roleTemp/updateSystemRolePermissionsTemplate", // 更新系统默认角色模板对于的权限列表

    //组织架构
    GLOBAL_org_getOrganizationalToSelectSignet: yx_prefix +
        "/auth/org/getOrganizationalToSelectSignet", //查询登录用户所属公司组织架构
    GLOBAL_org_update: yx_prefix + "/auth/org/updateOrg", //编辑完成
    GLOBAL_user_getV2: yx_prefix + "/auth/user/getV2", //获取管理员账号名字
    GLOBAL_org_getChildrens: yx_prefix + "/auth/org/getChildrens", //获取子公司列表

    //部门管理
    GLOBAL_department_getTree: yx_prefix + "/auth/department/getTree", //获取部门列表树
    GLOBAL_department_add: yx_prefix + "/auth/department/add", //添加部门
    GLOBAL_department_del: yx_prefix + "/auth/department/del", //删除部门
    GLOBAL_user_getUsers: yx_prefix + "/auth/user/getUsers", //获取当前公司员工
    GLOBAL_department_update: yx_prefix + "/auth/department/update", //部门更新
    GLOBAL_department_getListByOrg: yx_prefix + "/auth/department/getListByOrg", //查询该公司下所有部门列表

    //用户组管理
    GLOBAL_userGroup_getByDepartment: yx_prefix + "/auth/userGroup/getByDepartment", //获取用户组列表/userGroup/add
    GLOBAL_userGroup_add: yx_prefix + "/auth/userGroup/add", //添加用户组
    GLOBAL_userGroup_update: yx_prefix + "/auth/userGroup/update", //更新编辑行
    GLOBAL_userGroup_del: yx_prefix + "/auth/userGroup/del", //删除
    GLOBAL_user_getUsersByUserGroup: yx_prefix + "/auth/user/getUsersByUserGroup", //查看用户组成员
    GLOBAL_department_getLevelsByOrg: yx_prefix + "/auth/department/getLevelsByOrg", //查询该公司下所有部门(以级联层级结构展示)
    GLOBAL_department_getLevelsByOrgToUpdateSignet: yx_prefix +
        "/auth/department/getLevelsByOrgToUpdateSignet", //查询该公司下所有部门(以级联层级结构展示)
    GLOBAL_user_searchByOrgAndKeywords: yx_prefix + "/auth/user/searchByOrgAndKeywords", //用户名+手机号+部门id 的用户列表
    GLOBAL_auth_department_getOrgTreeByUpdateSignet: yx_prefix +
        "/auth/department/getLevelsByOrgToUpdateSignet", //编辑时获取设备所属组织

    //查看原图
    GLOBAL_file_fileInfo_getOriginalPictureURLByFileId: yx_prefix +
        "/file/fileInfo/getOriginalPictureURLByFileId", //查询指定文件的访问路径URL

    // 角色管理
    GLOBAL_role_getByOrg: yx_prefix + "/auth/role/getByOrg", //获取角色列表
    GLOBAL_role_getByUser: yx_prefix + "/auth/role/getByUser", //搜索
    GLOBAL_role_add: yx_prefix + "/auth/role/add", //添加
    GLOBAL_role_update: yx_prefix + "/auth/role/update", //更新编辑行
    GLOBAL_role_del: yx_prefix + "/auth/role/del", //删除
    GLOBAL_rolePerms_getByRole: yx_prefix + "/auth/rolePerms/getByRole", //获取树的权限列表
    GLOBAL_rolePerms_bindPerms: yx_prefix + "/auth/rolePerms/bindPerms", //点击树完成
    GLOBAL_role_searchByRole: yx_prefix + "/auth/role/searchByRoleWeb", //搜索
    //人员管理
    GLOBAL_user_getByOrg: yx_prefix + "/auth/user/getByOrg", //获取人员列表
    GLOBAL_user_update: yx_prefix + "/auth/user/update", //更新编辑行
    GLOBAL_user_del: yx_prefix + "/auth/user/del", //删除人员
    GLOBAL_application_applicationNode_fastTrans: yx_prefix + "/application/applicationNode/fastTrans", //转交人员
    GLOBAL_user_activation: yx_prefix + "/auth/user/activation", //激活
    GLOBAL_user_resetPassword: yx_prefix + "/auth/user/resetPassword", //员工重置密码
    GLOBAL_system_import_users: yx_prefix + "/system/import/users", //人员导入
    //用户注册
    GLOBAL_user_regist: yx_prefix + "/auth/user/reg", //编辑完成
    GLOBAL_user_checkPhone: yx_prefix + "/auth/user/checkPhone", //校验手机号是否在系统中已存在
    //系统管理
    GLOBAL_sysOrg_getByOwner: yx_prefix + "/auth/smsOrg/getByOwner", //获取短信通知模板
    GLOBAL_orgNotice_getByOwner: yx_prefix + "/auth/orgNotice/getByOwner", //获APP通知模板
    GLOBAL_sysOrg_changeSms: yx_prefix + "/auth/smsOrg/update", //开启关闭短信通知
    GLOBAL_orgNotice_update: yx_prefix + "/auth/orgNotice/update", //开启关闭App通知
    GLOBAL_auth_smsOrg_updateBulk: yx_prefix + "/auth/smsOrg/updateBulk", //批量启用、禁用
    GLOBAL_auth_orgNotice_updateBulk: yx_prefix + "/auth/orgNotice/updateBulk", //批量启用、禁用
    //申请用章
    GLOBAL_application_add: yx_prefix + "/application/application/add", //创建申请单
    GLOBAL_fileTemp_uploadFile: yx_prefix + "/file/fileInfo/uploadFile", //单文件上传文件、附件
    GLOBAL_fileTemp_uploadAndGetFile: yx_prefix + "/file/fileInfo/uploadAndGetFile", //单文件上传文件、附件返回url

    GLOBAL_config_addOrUpdateVersion: yx_prefix + "/device/config/addOrUpdateVersion", //更新apk地址
    GLOBAL_app_version_list: yx_prefix + "/auth/appVersion/getAll", //更新apk地址
    GLOBAL_configVersion_getList: yx_prefix + "/device/configVersion/getList", //查询设备apk版本列表
    GLOBAL_configVersion_add: yx_prefix + "/device/configVersion/add", //设备添加新版本APK
    GLOBAL_configVersion_del: yx_prefix + "/device/configVersion/del", //设备删除指定版本APK

    GLOBAL_config_getDefaultConfig: yx_prefix + "/device/config/getDefaultConfig", //查询全局配置
    GLOBAL_config_getLogByUUID: yx_prefix + "/device/config/getLogByUUID", //查看日志列表
    GLOBAL_config_reset: yx_prefix + "/device/config/reset", //查看日志列表

    GLOBAL_user_getManagers: yx_prefix + "/auth/user/getManagers", //获取所有审批人数据
    GLOBAL_user_getOrganizationalToApplicationForm: yx_prefix +
        "/auth/user/getOrganizationalToApplicationForm", //查询审批人列表
    GLOBAL_user_getOrganizationalToAddFlow: yx_prefix + "/auth/user/getOrganizationalToAddFlow", //查询审批人列表
    GLOBAL_auth_user_userListForReport: yx_prefix + "/auth/user/userListForReport", //用户列表

    //审批
    GLOBAL_application_getNotApprovedByOwn: yx_prefix + "/application/application/getNotApprovedByOwn", //获取待审批列表
    GLOBAL_application_getApprovedByOwn: yx_prefix + "/application/application/getApprovedByOwn", //获取已审批列表
    GLOBAL_application_getManagerApplicationById: yx_prefix +
        "/application/application/getManagerApplicationById", //审批处理详情
    GLOBAL_applicationManager_managerOK: yx_prefix + "/application/applicationNode/managerOK", //审批同意
    GLOBAL_applicationManager_managerFail: yx_prefix + "/application/applicationNode/managerFail", //审批驳回
    GLOBAL_applicationManager_managerTrans: yx_prefix + "/application/applicationNode/managerTrans", //审批转交中
    GLOBAL_application_applicationNode_getNextOptionalNode: yx_prefix +
        "/application/applicationNode/getNextOptionalNode", //自选

    //授权
    GLOBAL_application_getUnAuthorizedByOwn: yx_prefix + "/application/application/getUnAuthorizedByOwn", //获取待授权列表
    GLOBAL_application_getAuthorizedByOwn: yx_prefix + "/application/application/getAuthorizedByOwn", //获取已授权列表
    GLOBAL_application_getKeeperApplicationById: yx_prefix +
        "/application/application/getKeeperApplicationById", //授权处理详情
    GLOBAL_applicationKeeper_keeperOK: yx_prefix + "/application/applicationNode/keeperOK", //授权同意
    GLOBAL_applicationKeeper_KeeperFAIL: yx_prefix + "/application/applicationNode/keeperFAIL", //授权拒绝
    GLOBAL_applicationKeeper_pushApplicationToSignet: yx_prefix +
        "/application/application/pushApplicationToSignet", //授权推送
    GLOBAL_applicationKeeper_endApplicationToSignet: yx_prefix +
        "/application/application/endApplicationToSignet", //推送结束
    //审计
    GLOBAL_application_getNotAuditedByOwn: yx_prefix + "/application/application/getNotAuditedByOwn", //获取待审计列表
    GLOBAL_application_getAuditedByOwn: yx_prefix + "/application/application/getAuditedByOwn", //获取已审计列表
    GLOBAL_application_getAuditorApplicationById: yx_prefix +
        "/application/application/getAuditorApplicationById", //审计处理详情
    GLOBAL_applicationAuditor_auditorOK: yx_prefix + "/application/applicationNode/auditorOK", //正常
    GLOBAL_applicationAuditor_auditorFAIL: yx_prefix + "/application/applicationNode/auditorFAIL", //异常
    GLOBAL_applicationDealLog_getByApplication: yx_prefix +
        "/application/applicationNode/getByApplication", //获取审批流程

    GLOBAL_sealRecordInfo_getByApplicationId: yx_prefix + "/device/sealRecordInfo/getByApplicationId", //获取审批流程

    //使用记录
    GLOBAL_sealRecordInfo_searchInfoList: yx_prefix + "/device/sealRecordInfo/searchInfoListByKeyword", //模糊查询
    GLOBAL_application_getBySealRecordInfoToBind: yx_prefix +
        "/application/application/getBySealRecordInfoToBind", //查询指定使用记录可以绑定的申请单列表
    GLOBAL_sealRecordInfo_banding: yx_prefix + "/device/sealRecordInfo/banding", //绑定申请单
    GLOBAL_report_applicationReport: yx_prefix + "/device/report/applicationReport", //申请报表
    GLOBAL_report_getReport: yx_prefix + "/device/report/getReport", //查询登录用户报表列表
    GLOBAL_report_del: yx_prefix + "/device/report/del", //删除报表
    GLOBAL_system_infoStatusList: yx_prefix + "/system/infoStatusList", //记录状态列表
    GLOBAL_system_sealRecordInfoTypeList: yx_prefix + "/system/sealRecordInfoTypeList", //记录类型列表
    GLOBAL_system_useModelList: yx_prefix + "/system/useModelList", //使用模式列表
    GLOBAL_deviceManager_deviceInfoList: yx_prefix + "/deviceManager/deviceInfoList", //使用记录列表
    GLOBAL_deviceManager_infoDetail: yx_prefix + "/deviceManager/infoDetail", //使用记录详情
    GLOBAL_useCentreInfo_infoList: yx_prefix + "/useCentreInfo/infoList", //使用记录列表

    //设备管理
    GLOBAL_signet_getByOrg: yx_prefix + "/device/signet/getByOrg", //查询当前登录用户公司印章列表
    GLOBAL_signet_getByOwner: yx_prefix + "/device/signet/getByOwner", //查询当前登录用户公司(及子公司)印章列表
    GLOBAL_signet_getBySignet: yx_prefix + "/device/signet/getBySignet", //印章详细信息
    GLOBAL_auth_user_getAuditorsByUpdateDevice: yx_prefix +
        "/auth/user/getAuditorsByUpdateDevice", //查询可作为'印章审计员'员工列表
    GLOBAL_auth_user_getKeepersToUpdateDevice: yx_prefix + "/auth/user/getKeepersToUpdateDevice", //查询可作为'印章管理员'员工列表
    GLOBAL_signet_del: yx_prefix + "/device/signet/del", //删除印章
    GLOBAL_signet_initializtion: yx_prefix + "/device/signet/initializtion", //清除次数
    GLOBAL_signet_migrate: yx_prefix + "/device/signet/migrate", //迁移印章
    GLOBAL_user_getFingerUserBySignet: yx_prefix + "/auth/user/getFingerUserBySignet", //查询未录入的用户列表信息
    GLOBAL_finger_fingerPrint: yx_prefix + "/device/finger/fingerPrint", //指纹录入
    GLOBAL_finger_cleanOne: yx_prefix + "/device/finger/cleanOne", //指纹删除
    GLOBAL_finger_cleanAll: yx_prefix + "/device/finger/cleanAll", //指纹全部清空
    GLOBAL_signet_update: yx_prefix + "/device/signet/update", //编辑完成
    GLOBAL_deviceType_getByOrg: yx_prefix + "/device/deviceType/getByOrg", //获取印章类别

    GLOBAL_signet_getWifiList: yx_prefix + "/device/signet/getWifiList", //查询印章附件wifi列表
    GLOBAL_signet_setWifiLink: yx_prefix + "/device/signet/setWifiLink", //wifi连接
    GLOBAL_signet_closeWifi: yx_prefix + "/device/signet/closeWifi", //wifi断开
    GLOBAL_signet_getLogFile: yx_prefix + "/device/signet/getLogFile", //通知设备上传日志文件
    GLOBAL_device_signet_setDormancy: yx_prefix + "/device/signet/setDormancy", //设置印章休眠时间
    GLOBAL_device_signet_openPatternFinger: yx_prefix + "/device/signet/openPatternFinger", //开启指纹模式
    GLOBAL_device_signet_remoteUnlock: yx_prefix + "/device/signet/remoteUnlock", // 远程解锁
    GLOBAL_device_signet_setRemoteLock: yx_prefix + "/device/signet/setRemoteLock", //远程锁定
    GLOBAL_device_signet_installationChapterHead: yx_prefix + "/device/signet/installationChapterHead", //远程装章
    GLOBAL_device_signet_deviceListForReport: yx_prefix + "/device/signet/deviceListForReport", //获取印章列表
    GLOBAL_device_report_getReportList: yx_prefix + "/device/report/getReportList", //查询报表列表记录
    GLOBAL_device_config_enabledApplication: yx_prefix + "/device/config/enabledApplication", //设备使能_申请单
    GLOBAL_device_config_enabledProductionTest: yx_prefix + "/device/config/enabledProductionTest", //设备使能_产测
    GLOBAL_device_config_enabledList: yx_prefix + "/device/config/enabledList", //设备使能_产测
    GLOBAL_useCentreInfo_videoList: yx_prefix + "/useCentreInfo/videoList", //视频记录
    /**
     * 指纹同步相关
    */
    GLOBAL_findDeviceFingers: "/device/finger/findDeviceFingers", // 获取系统所有设备指纹相关列表
    GLOBAL_findByDepartmentId: "/device/signet/findByDepartmentId/", // 获取机构下所有设备列表
    GLOBAL_performFingerprintSynchronization: "/device/finger/task/create", // 提交同步指纹任务信息
    GLOBAL_finger_task_list: "/device/finger/task/findList", // 查询指纹同步任务列表
    GLOBAL_finger_task_find: "/device/finger/task/find/", // 查询指纹同步任务详情
    GLOBAL_finger_task_remove: "/device/finger/task/remove/", // 删除同步任务
    GLOBAL_finger_task_execute: "/device/finger/task/execute/", // 执行同步任务
    GLOBAL_finger_task_interrupt: "/device/finger/task/interrupt/", // 停止同步任务
    GLOBAL_finger_task_findTaskStateList: "/device/finger/task/findTaskStateList", // 任务状态列表

    // 数据统计
    GLOBAL_report_getStatistics: yx_prefix + "/device/report/getStatistics", //查询公司 申请单总数/使用记录总数/印章总数
    GLOBAL_report_getHistogram: yx_prefix + "/device/report/getHistogram", //查询该公司各印章使用总次数(柱状图)
    GLOBAL_report_getMapChart: yx_prefix + "/device/report/getMapChart", //查询该公司各印章使用总次数(地图)
    GLOBAL_report_getErrorOrNormal: yx_prefix + "/device/report/getErrorOrNormal", //异常/正常/警告(饼状图)
    GLOBAL_signet_getTotalByOnline: yx_prefix + "/device/report/getTotalByOnline", //在线印章数,及总数(仪表图)

    //平台
    GLOBAL_orgServe_getAll: yx_prefix + "/auth/orgServe/getAll", //获取组织的信息
    GLOBAL_orgServe_updateSMS: yx_prefix + "/auth/orgServe/updateSMS", //更新短信服务
    GLOBAL_orgServe_updateDevice: yx_prefix + "/auth/orgServe/updateDevice", //更新基础服务
    GLOBAL_orgServe_updateOOS: yx_prefix + "/auth/orgServe/updateOOS", //上传天翼云
    GLOBAL_orgServe_updateQSS: yx_prefix + "/auth/orgServe/updateQSS", //更新公司量子服务
    GLOBAL_qss_getAll: yx_prefix + "/auth/qss/getAll", //查询所有量子加解密URL列表
    GLOBAL_qss_del: yx_prefix + "/auth/qss/del", //删除对应量子加解密URL
    GLOBAL_qss_add: yx_prefix + "/auth/qss/add", //添加量子加密URL
    GLOBAL_qss_update: yx_prefix + "/auth/qss/update", //编辑量子加密URL
    GLOBAL_qss_getByArray: yx_prefix + "/auth/qss/getByArray", //查询所有量子加解密URL数组
    GLOBAL_messageTemp_getAll: yx_prefix + "/auth/messageTemp/getAll", //查询通知/短信模板配置列表
    GLOBAL_noticeTemp_getList: yx_prefix + "/auth/noticeTemp/getList", //查询通知模板列表
    GLOBAL_smsTemp_getList: yx_prefix + "/auth/smsTemp/getList", //查询短信模板列表
    GLOBAL_messageTemp_update: yx_prefix + "/auth/messageTemp/update", //更新 短信/通知模板配置
    GLOBAL_appVersion_add: yx_prefix + "/auth/appVersion/add", //app版本更新
    GLOBAL_appVersion_del: yx_prefix + "/auth/appVersion/del", //app版本删除
    GLOBAL_appVersion_getAll: yx_prefix + "/auth/appVersion/getAll", //app版本列表
    GLOBAL_device_log_getLogByDeviceIdAndUseCount: yx_prefix + "/device/log/getLogByDeviceIdAndUseCount", //异常信息捕获
    GLOBAL_device_deviceMigrateLog_getList: yx_prefix + "/deviceMigrateLog/findList", //迁章记录

    //首页
    GLOBAL_userLogger_getByUser: yx_prefix + "/auth/userLogger/getByUser", //查询最近使用日志列表
    GLOBAL_org_getByOwner: yx_prefix + "/auth/org/getByOwner", //查询登录用户公司信息
    GLOBAL_application_getDataByOwner: yx_prefix +
        "/application/application/getDataByOwner", //查询登录用户待审计/待审批/待授权/待处理申请单 信息
    //流程管理
    GLOBAL_flow_getByOwner: yx_prefix + "/application/flow/getByOwner", //查询登录用户审批流程列表(类型名称,审批人列表)
    GLOBAL_flow_getAll: yx_prefix + "/application/flow/getAll", //查询登录用户审批流程列表(类型名称,审批人列表)
    GLOBAL_flow_getVo: yx_prefix + "/application/flow/getVo", //编辑时,查询审批流程图实例
    GLOBAL_flow_updateNodes: yx_prefix + "/application/flow/updateNodes", //修改审批流程图
    GLOBAL_flow_update: yx_prefix + "/application/flow/update", //修改审批流程
    GLOBAL_flow_del: yx_prefix + "/application/flow/del", //删除审批流程
    GLOBAL_application_node_history_findHistoryList: yx_prefix +
        "/application/node/history/findHistoryList", //{applicationNodeId}查询审批流转历史

    //密码策略
    GLOBAL_strategypassword_get: yx_prefix + "/auth/strategypassword/get", //获取当前公司的密码策略
    GLOBAL_strategypassword_update: yx_prefix + "/auth/strategypassword/update", //修改当前公司的密码策略
    GLOBAL_strategypassword_getTips: yx_prefix + "/auth/strategypassword/getTips", //获取当前密码策略提示信息
    //阈值
    GLOBAL_signet_getThresholds: yx_prefix + "/device/signet/getThresholds", //获取所有设备的阈值
    GLOBAL_signet_getThresholdInfo: yx_prefix + "/device/signet/getThresholdInfo", //获取当前设备阈值信息
    GLOBAL_signet_updateThreshold: yx_prefix + "/device/signet/updateThreshold", //修改设备阈值信息
    //印章配置
    GLOBAL_config_getConfigList: yx_prefix + "/device/config/findDeviceConfigurationList", //获取平台所有印章配置列表信息
    GLOBAL_config_addOrUpdateConfig: yx_prefix + "/device/config/addOrUpdateConfig", //添加/更新 印章的配置信息
    //微信小程序相关
    GLOBAL_wechat_control_add: yx_prefix + "/wechat/control/add", //添加小程序
    GLOBAL_wechat_control_list: yx_prefix + "/wechat/control/list", //小程序列表
    GLOBAL_wechat_control_delete: yx_prefix + "/wechat/control/delete", //删除
    GLOBAL_wechat_control_update: yx_prefix + "/wechat/control/update", //更新
    //导出申请单相关
    GLOBAL_auth_user_userList: yx_prefix + "/auth/user/userList", //员工列表
    GLOBAL_device_signet_deviceList: yx_prefix + "/device/signet/deviceList", //设备列表
    GLOBAL_application_application_statusList: yx_prefix + "/application/application/statusList", //申请单状态列表
    GLOBAL_device_report_applicationFormList: yx_prefix + "/device/report/applicationFormList", //查询报表列表记录
    //电子印签功能模块开始
    //银行
    GLOBAL_electronic_bank_findList: yx_prefix + "/electronic/bank/findList", //列表查询
    //企业
    GLOBAL_electronic_enterprise_create: yx_prefix + "/electronic/enterprise/create", //提交企业认证信息
    GLOBAL_electronic_enterprise_findDepartment: yx_prefix +
        "/electronic/enterprise/findDepartment", ///{departmentId}查询
    GLOBAL_electronic_enterprise_microPaymentVerify: yx_prefix +
        "/electronic/enterprise/microPaymentVerify", //企业小额打款验证
    GLOBAL_electronic_enterprise_retry: yx_prefix + "/electronic/enterprise/retry", //{enterpriseId}重新认证
    GLOBAL_electronic_enterprise_findList: yx_prefix + "/electronic/enterprise/findList", //列表查询
    GLOBAL_electronic_enterprise_openingAccountApply: yx_prefix +
        "/electronic/enterprise/openingAccountApply", //{enterpriseId}申请开户

    //电子印章
    GLOBAL_electronic_seal_findList: yx_prefix + "/electronic/seal/findList", //列表查询
    GLOBAL_electronic_seal_edit: yx_prefix + "/electronic/seal/edit", //修改
    GLOBAL_electronic_seal_remove: yx_prefix + "/electronic/seal/remove", //{id}删除
    GLOBAL_electronic_seal_create: yx_prefix + "/electronic/seal/create", //添加电子印章
    GLOBAL_electronic_seal_findDeviceList: yx_prefix + "/electronic/seal/findDeviceList", //{departmentId}硬件设备列表
    GLOBAL_electronic_enterprise_department_findList: yx_prefix +
        "/electronic/enterprise/department/findList", //查询组织列表
    GLOBAL_electronic_enterprise_department_findTree: yx_prefix +
        "/electronic/enterprise/department/findTree", //查询组织树
    GLOBAL_electronic_device_findList: yx_prefix + "/electronic/device/findList", //{departmentId}查询实体印章列表
    GLOBAL_electronic_seal_findHardwareList: yx_prefix + "/electronic/seal/findHardwareList", //{{sealId}}实体印章列表
    GLOBAL_electronic_seal_bind: yx_prefix + "/electronic/seal/bind", //关联实体印章
    GLOBAL_electronic_seal_unbind: yx_prefix + "/electronic/seal/unbind", //解绑实体印章
    GLOBAL_electronic_seal_apply: yx_prefix + "/electronic/seal/apply", //{sealId}申请CA证书
    GLOBAL_electronic_seal_revoked: yx_prefix + "/electronic/seal/revoked", //{certificateId}注销CA证书
    //经办人
    GLOBAL_electronic_transactor_findUserList: yx_prefix +
        "/electronic/transactor/findUserList", //{departmentId}列表查询
    GLOBAL_electronic_transactor_create: yx_prefix + "/electronic/transactor/create", //新增
    GLOBAL_electronic_transactor_user_findList: yx_prefix +
        "/electronic/transactor/findEnabledTransactorUserList", //{departmentId}查询机构经办人用户列表
    GLOBAL_electronic_transactor_findAllTransactorUserList: yx_prefix +
        "/electronic/transactor/findAllTransactorUserList", //{departmentId}查询机构经办人用户列表
    GLOBAL_electronic_transactor_findList: yx_prefix + "/electronic/transactor/findList", //列表查询
    GLOBAL_electronic_transactor_remove: yx_prefix + "/electronic/transactor/remove", //{id}删除
    GLOBAL_electronic_transactor_edit: yx_prefix + "/electronic/transactor/edit", //修改
    //企业经办人
    GLOBAL_electronic_transactor_findOwnerEnterpriseList: yx_prefix +
        "/electronic/transactor/findOwnerEnterpriseList", //所属企业列表

    //审计人
    GLOBAL_electronic_auditor_findList: yx_prefix + "/electronic/auditor/findList", //{departmentId}查询电子印章审计员列表
    //签署方
    GLOBAL_electronic_enterprise_liaison_create: yx_prefix + "/electronic/enterprise/liaison/create", //添加签署方
    GLOBAL_electronic_enterprise_liaison_findList: yx_prefix + "/electronic/enterprise/liaison/findList", //列表查询
    GLOBAL_electronic_enterprise_liaison_remove: yx_prefix + "/electronic/enterprise/liaison/remove", //{id}删除
    GLOBAL_electronic_enterprise_liaison_findEnterprise: yx_prefix +
        "/electronic/enterprise/liaison/findEnterprise", //{fullName}系统企业全称查询
    //合同
    GLOBAL_electronic_contract_create: yx_prefix + "/electronic/contract/create", //新增合同
    GLOBAL_electronic_contract_findList: yx_prefix + "/electronic/contract/findList", //合同列表
    GLOBAL_electronic_contract_file_uploadContractFile: yx_prefix +
        "/electronic/contract/file/uploadContractFile", //上传合同文件
    GLOBAL_electronic_contract_submit: yx_prefix + "/electronic/contract/submit", //{contractId}提交合同
    GLOBAL_electronic_contract_findEnterpriseLiaisonList: yx_prefix +
        "/electronic/contract/findEnterpriseLiaisonList", //查询企业签署方列表
    GLOBAL_electronic_contract_downloadContract: yx_prefix +
        "/electronic/contract/downloadContract", //{contractId}下载合同

    //企业合同
    GLOBAL_electronic_enterprise_contract_findList: yx_prefix + "/electronic/enterprise/contract/findList", //企业合同列表
    GLOBAL_electronic_enterprise_contract_extract: yx_prefix + "/electronic/enterprise/contract/extract", //提取合同
    GLOBAL_electronic_enterprise_contract_find: yx_prefix + "/electronic/enterprise/contract/find", //{id}企业合同详情
    GLOBAL_electronic_enterprise_contract_sign: yx_prefix + "/electronic/enterprise/contract/sign", //签署
    GLOBAL_electronic_enterprise_contract_save: yx_prefix + "/electronic/enterprise/contract/save", //保存
    GLOBAL_electronic_enterprise_contract_remark: yx_prefix + "/electronic/enterprise/contract/remark", //备注
    GLOBAL_electronic_helper_findEnterpriseContractStatusList: yx_prefix +
        "/electronic/helper/findEnterpriseContractStatusList", //企业合同状态列表
    GLOBAL_electronic_enterprise_contract_refused: yx_prefix + "/electronic/enterprise/contract/refused", //拒绝签署
    GLOBAL_electronic_enterprise_contract_findOwnerEnterpriseList: yx_prefix +
        "/electronic/enterprise/contract/findOwnerEnterpriseList", //所属企业列表

    //电子申请用章
    GLOBAL_electronic_enterprise_application_findFlowList: yx_prefix +
        "/electronic/enterprise/application/findFlowList", //{sealId}审批流程列表
    GLOBAL_electronic_enterprise_application_findManagerList: yx_prefix +
        "/electronic/enterprise/application/findManagerList", //审批人列表
    GLOBAL_electronic_enterprise_application_findAvailableElectronicList: yx_prefix +
        "/electronic/enterprise/application/findAvailableElectronicList", //可用(申请)电子印章列表
    GLOBAL_electronic_enterprise_application_findAvailableContractList: yx_prefix +
        "/electronic/enterprise/application/findAvailableContractList", //可申请的合同列表
    GLOBAL_electronic_enterprise_application_createEnterpriseElectronicSealApplication: yx_prefix +
        "/electronic/enterprise/application/createEnterpriseElectronicSealApplication", //提交企业电子印章的用印申请
    //电子验证码
    GLOBAL_electronic_message_authenticationCode_sendSMSAuthenticationCode: yx_prefix +
        "/electronic/message/authenticationCode/sendSMSAuthenticationCode", //{enterpriseApplicationId}发送短信验证码
    GLOBAL_electronic_message_authenticationCode_verifySMSAuthenticationCode: yx_prefix +
        "/electronic/message/authenticationCode/verifySMSAuthenticationCode", //{authenticationCode}确认短信验证码
    //签约次数管理
    GLOBAL_electronic_seal_limit_edit: yx_prefix + "/electronic/seal/limit/edit", //修改
    GLOBAL_electronic_seal_limit_findList: yx_prefix + "/electronic/seal/limit/findList", //列表查询
    GLOBAL_electronic_seal_limit_findPlatLimit: yx_prefix + "/electronic/seal/limit/findPlatLimit", //查询平台阈值
    GLOBAL_electronic_seal_limit_remove: yx_prefix + "/electronic/seal/limit/remove", //{id}删除
    GLOBAL_electronic_enterprise_liaison_findOwnerEnterpriseList: yx_prefix +
        "/electronic/enterprise/liaison/findOwnerEnterpriseList", //所属企业列表

    //ca证书
    GLOBAL_electronic_ca_apply: yx_prefix + "/electronic/ca/apply", //{sealId}申请CA证书
    GLOBAL_electronic_ca_findList: yx_prefix + "/electronic/ca/findList", //CA证书列表
    GLOBAL_electronic_ca_refresh: yx_prefix + "/electronic/ca/refresh", //{certificateId}更新CA证书
    GLOBAL_electronic_ca_revoked: yx_prefix + "/electronic/ca/revoked", //{certificateId}注销CA证书
    GLOBAL_electronic_helper_findCABindStatusList: yx_prefix + "/electronic/helper/findCABindStatusList", //CA证书状态列表
    GLOBAL_electronic_ca_findEnabledEnterpriseList: yx_prefix +
        "/electronic/ca/findEnabledEnterpriseList", //CA证书可选企业列表
    GLOBAL_electronic_ca_findEnabledDeviceList: yx_prefix + "/electronic/ca/findEnabledDeviceList", //承载CA证书的实体印章列表
    GLOBAL_electronic_seal_findEnabledCertificateList: yx_prefix +
        "/electronic/seal/findEnabledCertificateList", //查询可被绑定电子印章的CA证书列表
    GLOBAL_electronic_seal_associated: yx_prefix + "/electronic/seal/associated", //关联CA证书
    GLOBAL_electronic_enterprise_application_applyCaAuthorized: yx_prefix +
        "/electronic/enterprise/application/applyCaAuthorized", //{enterpriseApplicationId}请求CA授权
    GLOBAL_electronic_enterprise_application_findAuthorized: yx_prefix +
        "/electronic/enterprise/application/findAuthorized", //{enterpriseApplicationId}查询企业申请单授权状态
    GLOBAL_electronic_ca_findOwnerEnterpriseList: yx_prefix + "/electronic/ca/findOwnerEnterpriseList", //所属企业列表
    //电子印章使用记录
    GLOBAL_electronic_seal_findSealInfoList: yx_prefix + "/electronic/seal/findSealInfoList", //查询电子印章使用记录
    GLOBAL_electronic_seal_findContractDetail: yx_prefix + "/electronic/seal/findContractDetail", //{sealInfoId}合同详情
    GLOBAL_electronic_seal_infoRemark: yx_prefix + "/electronic/seal/infoRemark", //用印记录添加备注
    GLOBAL_electronic_seal_info_findList: yx_prefix + "/electronic/seal/info/findList", //使用记录
    GLOBAL_electronic_seal_info_findContractDetail: yx_prefix + "/electronic/seal/info/findContractDetail", //合同详情
    GLOBAL_electronic_seal_info_remark: yx_prefix + "/electronic/seal/info/remark", //添加备注
    GLOBAL_device_signet_findDeviceInfo: yx_prefix + "/device/signet/findDeviceInfo", //{deviceId}实体设备详情

    GLOBAL_sealRecord_faceImg_findList: yx_prefix + "/sealRecord/faceImg/findList", //人脸列表
    GLOBAL_sealRecord_faceImg_findFaceImage: yx_prefix + "/sealRecord/faceImg/findFaceImage", //人脸详情
    GLOBAL_sealRecord_faceImg_editRemark: yx_prefix + "/sealRecord/faceImg/editRemark", // 备注

    //电子印章模块结束
    //app图标
    GLOBAL_phone_icon_findList: yx_prefix + "/phone/icon/findList", //添加备注
    GLOBAL_phone_icon_create: yx_prefix + "/phone/icon/create", //增加APP图标
    GLOBAL_phone_icon_edit: yx_prefix + "/phone/icon/edit", //修改APP图标
    GLOBAL_phone_icon_editGroup: yx_prefix + "/phone/icon/editGroup", //修改APP图标组
    GLOBAL_phone_icon_remove: yx_prefix + "/phone/icon/remove", //phoneIconId删除APP图标

    // 印章柜管理相关
    GLOBAL_cabinet_findList: "/cabinet/findList", // 印章柜列表
    GLOBAL_cabinet_findDetail: "/cabinet/findDetail", // 印章柜详情
    GLOBAL_cabinet_create: "/cabinet/create", // 修改印章柜详情
    GLOBAL_cabinet_edit: "/cabinet/edit", // 修改印章柜详情
    // 印章柜柜门管理
    GLOBAL_cabinet_door_findList: "/cabinetDoor/findList", // 印章柜柜门列表
    GLOBAL_cabinet_door_edit: "/cabinetDoor/edit", // 印章柜柜门编辑
    GLOBAL_auth_org_getDepartmentAndUser: "/auth/org/getDepartmentAndUser", // 查询组织结构用于印章柜
    // 印章柜绑定、解绑管理
    GLOBAL_cabinet_bind_create: "/cabinetBind/create", // 印章柜柜门列表
    GLOBAL_auth_org_getDepartmentAndSignet: "/auth/org/getDepartmentAndSignet", // 组织下的印章列表
    GLOBAL_cabinetBind_edit: "/cabinetBind/edit", // 获取所有印章
    GLOBAL_cabinetBind_remove: "/cabinetBind/remove", // 删除印章绑定
    GLOBAL_cabinetBind_batch: "/cabinetBind/batch", // 批量导入
    // 印章柜用户管理接口
    GLOBAL_cabinetUser_findList: "/cabinetUser/findList", // 人员认证列表
    GLOBAL_cabinetUser_remove: "/cabinetUser/remove", // 根据id删除人员认证
    GLOBAL_device_signet_getByAddressList: "/device/signet/getByAddressList", // 获取所有印章
    // 印章柜配置管理
    GLOBAL_cabinet_config_findCabinetConfigurationList: "/cabinet/config/findCabinetConfigurationList", // 获取在线设备
    GLOBAL_cabinet_config_findOrganizationList: "/cabinet/config/findOrganizationList", // 获取组织
    GLOBAL_cabinet_migrate: "/cabinet/migrate", // 迁移印章柜
    //app升级中心
    GLOBAL_app_upgrade_create: "/app/upgrade/create", // 新增
    GLOBAL_app_upgrade_edit: "/app/upgrade/edit", // 修改
    GLOBAL_app_upgrade_find: "/app/upgrade/find", // 查询
    GLOBAL_app_upgrade_findList: "/app/upgrade/findList", // 列表查询
    GLOBAL_app_upgrade_remove: "/app/upgrade/remove", // 删除
    GLOBAL_app_upgrade_uploadAppUpgradeFile: "/app/upgrade/uploadAppUpgradeFile", // 上传app更新包文件
    //印控台
    GLOBAL_tenant_hspa_device_hspaDevices: "/tenant/hspa/device/hspaDevices", // 印控台列表
    GLOBAL_tenant_hspa_device_bind: "/tenant/hspa/device/bind", // 绑定设备
    GLOBAL_tenant_hspa_device_querySignetList: "/tenant/hspa/device/querySignetList", // 所有设备列表
    GLOBAL_tenant_hspa_device_queryBindSignets: "/tenant/hspa/device/queryBindSignets", // 已绑定的设备列表
    GLOBAL_tenant_hspa_device_update: "/tenant/hspa/device/update", // 更新印控台
    GLOBAL_tenant_hspa_device_organizationTrees: "/tenant/hspa/device/organizationTrees", // 组织机构树列表
    GLOBAL_tenant_hspa_device_resetPass: "/tenant/hspa/device/resetPass", // 重置密码

    //印控台配置
    GLOBAL_plat_hspa_device_hspaDevices: "/plat/hspa/device/hspaDevices", // 印控台列表
    GLOBAL_plat_hspa_device_migrationTenants: "/plat/hspa/device/migrationTenants", // 租户列表
    GLOBAL_plat_hspa_device_migrateTenant: "/plat/hspa/device/migrateTenant", // 迁移
    GLOBAL_plat_hspa_device_deleteHspaDevice: "/plat/hspa/device/deleteHspaDevice", //删除
    //系统属性配置
    GLOBAL_sys_config_property_findList: "/sys/config/property/findList", //属性列表
    GLOBAL_sys_config_property_edit: "/sys/config/property/edit", //编辑
    GLOBAL_sys_config_property_create: "/sys/config/property/create", //添加
    GLOBAL_sys_config_property_remove: "/sys/config/property/remove", //删除
    //查看授权码
    GLOBAL_application_application_authorizationCode: "/application/application/authorizationCode", //查看授权码

    //电子围栏
    GLOBAL_device_electronic_fence_findList: "/device/electronic/fence/findList", //列表查询
    GLOBAL_device_electronic_fence_create: "/device/electronic/fence/create", //新增电子围栏
    GLOBAL_device_electronic_fence_edit: "/device/electronic/fence/edit", //修改电子围栏
    GLOBAL_device_electronic_fence_remove: "/device/electronic/fence/remove", //删除
    //日志管理
    GLOBAL_system_logger_logFileList: "/system/logger/logFileList", //日志文件列表
    GLOBAL_system_logger_readLogFile: "/system/logger/readLogFile", //读取日志内容
    GLOBAL_system_logger_configureLogLevel: "/system/logger/configureLogLevel", //设置日志级别
    GLOBAL_system_logger_downloadBack: "/system/logger/downloadBack", //断点续传

    // 申请类型
    GLOBAL_application_type_create: "/application/type/create", //添加申请类型
    GLOBAL_application_type_edit: "/application/type/edit", //修改申请类型
    GLOBAL_application_type_find: "/application/type/find", //查询
    GLOBAL_application_type_findList: "/application/type/findList", //列表查询
    GLOBAL_application_type_remove: "/application/type/remove", //删除申请类型
    GLOBAL_application_type_findCompanyTree: "/application/type/findCompanyTree", //公司树列表
    GLOBAL_application_type_findSealUsers: "/application/type/findSealUsers", //专人列表
    GLOBAL_application_type_findSimpleList: "/application/type/findSimpleList", //简单列表查询
    GLOBAL_application_type_findSealUserInfos: "/application/type/findSealUserInfos", //申请类型_盖章专员信息列表
    GLOBAL_application_application_create: "/application/application/create", //申请用章

    //字典管理
    GLOBAL_system_dict_findDictList: "/system/dict/findDictList", //字典管理

    //智能ocr
    GLOBAL_application_ocr_findApplications: "/application/ocr/findApplications", //申请单列表
    GLOBAL_application_ocr_findBeforeUseSimilarRates: "/application/ocr/findBeforeUseSimilarRates", //事前相似率
    GLOBAL_application_ocr_findCurrentUseSimilarRates: "/application/ocr/findCurrentUseSimilarRates", //事中相似率
    GLOBAL_application_ocr_findAfterUseSimilarRates: "/application/ocr/findAfterUseSimilarRates", //事后相似率
    GLOBAL_application_ocr_submitAuditReason: "/application/ocr/submitAuditReason", //提交审核建议
    GLOBAL_application_ocr_findBeforeUseCompareInfo: "/application/ocr/findBeforeUseCompareInfo", //事前对比详情
    GLOBAL_application_ocr_findAfterUseCompareInfo: "/application/ocr/findAfterUseCompareInfo", //事后对比详情
    //应用管理
    GLOBAL_ac_app_findList: "/ac/app/findList", //列表查询
    GLOBAL_ac_app_create: "/ac/app/create", //创建应用
    GLOBAL_ac_app_edit: "/ac/app/edit", //修改
    GLOBAL_ac_app_remove: "/ac/app/remove", //删除
    //租户
    GLOBAL_ac_app_findTenants: "/ac/app/findTenants", //列表查询
    GLOBAL_ac_app_bindTenant: "/ac/app/bindTenant", //应用绑定租户
    GLOBAL_ac_app_createTenant: "/ac/app/createTenant", //创建
    GLOBAL_ac_app_updateTenant: "/ac/app/updateTenant", //编辑
    //日志
    GLOBAL_ac_event_log_findList: "/ac/event/log/findList", //列表查询
    //事件
    GLOBAL_ac_app_event_findList: "/ac/app/event/findList", //列表查询
    GLOBAL_ac_app_event_create: "/ac/app/event/create", //添加订阅
    GLOBAL_ac_app_event_delete: "/ac/app/event/delete", //删除订阅
    GLOBAL_ac_app_event_edit: "/ac/app/event/edit", //修改
    GLOBAL_ac_app_event_eventTypes: "/ac/event/eventTypes", //事件类型
    GLOBAL_ac_event_findList: "/ac/event/findList", //事件类型
    //数据权限
    GLOBAL_auth_role_updateDataScope: "/auth/role/updateDataScope", //修改数据权限
    GLOBAL_auth_role_dataScopeTrees: "/auth/role/dataScopeTrees", //自定义时获取数据权限组织树的接口
    GLOBAL_auth_role_dataScopeTypes: "/auth/role/dataScopeTypes", //数据权限类型

    //登录
    GLOBAL_auth_org_loginType: "/auth/org/loginType", //获取登录方式
    GLOBAL_auth_user_login: "/auth/user/login", //登录
    GLOBAL_auth_user_sendComplexCode: "/auth/user/sendComplexCode", //发送双因子登录验证码
    //跳转页面
    GLOBAL_third_jumpLink_findApplicationIds: "/third/jumpLink/findApplicationIds", //申请单列表
    GLOBAL_third_jumpLink_findDeptTreeList: "/third/jumpLink/findDeptTreeList", //组织机构列表
    GLOBAL_business_docking_exchangeTokens: "/business/docking/exchangeTokens", //获取用户信息
    GLOBAL_third_jumpLink_findApplicationInfo: "/third/jumpLink/findApplicationInfo", //获取用户信息
    GLOBAL_win_findApplicationInfo: "/business/docking/ssoCheck", // 获取用户信息(小赢科技)
    GLOBAL_nationalEnergyLogin: "/nationalEnergy/account/login", // 获取用户信息(国能集团)
    GLOBAL_yuchang_findApplicationInfo: "/business/docking/userCheck", // 获取用户信息(裕昌)
    GLOBAL_third_jumpLink_findRecordInfos: "/third/jumpLink/findRecordInfos", //使用记录
    GLOBAL_third_jumpLink_findDeviceInfos: "/third/jumpLink/findDeviceInfos", //设备列表
    GLOBAL_shuzhiYLSso: "/business/docking/shuzhiYLSso", // 数智云联单点登录
    //归档管理
    GLOBAL_application_archive_tobeArchiveList: "/application/archive/tobeArchiveList", //待归档
    GLOBAL_application_archive_archivedList: "/application/archive/archivedList", //已归档
    GLOBAL_application_archive_todoArchive: "/application/archive/todoArchive", //执行归档
    GLOBAL_application_archive_resetArchive: "/application/archive/resetArchive", //重新归档
    GLOBAL_application_archive_batchPack: "/application/archive/batchPack", //批量下载
    //图文搜索
    GLOBAL_data_search_imageText: "/data/search/imageText", //图文搜索
    GLOBAL_data_search_imageInfo: "/data/search/imageInfo", //图文详情
    //告警通知
    device_signet_closeOfflineTimeAlarm: "/device/signet/closeOfflineTimeAlarm", //告警通知关闭
    device_signet_openOfflineTimeAlarm: "/device/signet/openOfflineTimeAlarm", //告警通知开启
    //企业微信
    GLOBAL_applet_application_uploadAndGetFile: "/applet/application/uploadAndGetFile", //上传
    GLOBAL_wx_rolePerms_save: "/wx/rolePerms/save", //保存菜单权限
    GLOBAL_wx_rolePerms_getByRole: "/wx/rolePerms/getByRole", //权限列表
    GLOBAL_applet_application_wxRotationChartList: "/applet/application/wxRotationChartList", //轮播图列表
    GLOBAL_wx_rolePerms_editPerm: "/wx/rolePerms/editPerm", //编辑权限(企业微信)
    GLOBAL_applet_getConfigByOrg: "/applet/getConfigByOrg", //获取租户配置信息
    GLOBAL_applet_getUserInfoWeb: "/applet/getUserInfoWeb", //登录
    GLOBAL_applet_application_wxRotationChartDel: "/applet/application/wxRotationChartDel", //轮播图删除
    GLOBAL_templet_findList: "/templet/findList", //模板列表
    GLOBAL_templet_create: "/templet/create", //创建模板
    GLOBAL_templet_edit: "/templet/edit", //编辑模板
    GLOBAL_templet_delete: "/templet/delete", //删除模板
    GLOBAL_templet_getTemplateList: "/templet/getTemplateList", //模板
    GLOBAL_templet_synchTemplate: "/templet/synchTemplate", //绑定模板
    //扫码(设备解绑)
    GLOBAL_device_signet_migrateForApp: "/device/signet/migrateForApp",

    //钉钉
    GLOBAL_dingtalk_getUserInfoWeb: "/dingtalk/getUserInfoWeb", //登录
    //wps
    GLOBAL_v1_api_file_getUrl: "/v1/api/file/getUrl",

    // 消息告警-首页
    GLOBAL_notice_alarm: "/auth/notice/alarm",

    //满帮对接
    GLOBAL_application_application_getByOwnerApplicationsV2: "/application/application/getByOwnerApplicationsV2", //列表
    GLOBAL_application_application_getByMyApplicationV2: "/application/application/getByMyApplicationV2", //详情
    //长住
    GLOBAL_application_application_getByOwnerApplicationsV3: "/application/application/getByOwnerApplicationsV3", //列表 //详情

    // 仿群杰
    // 物理印章
    physical_seal_createApplication: "/physical/seal/carved/createApplication", // 创建刻章申请
    physical_seal_flowList: "/physical/seal/carved/flowList", // 流程列表
    physical_seal_carvedList: "/physical/seal/carved/list", // 查询刻章列表
    physical_seal_managerList: "/physical/seal/carved/managerList", // 审批人列表
    physical_seal_materialList: "/physical/seal/carved/materialList", // 刻章材质列表
    physical_seal_shapeList: "/physical/seal/carved/shapeList", // 刻章形状列表
    physical_seal_typeList: "/physical/seal/carved/typeList", // 刻章类型列表
    physical_seal_statusList: "/physical/seal/statusList", // 物理印章状态枚举（不包含销毁）
    physical_seal_binding: "/physical/seal/binding", // 绑定
    physical_seal_create: "/physical/seal/create", // 添加物理印章
    physical_seal_list: "/physical/seal/list", // 条件查询列表
    physical_seal_dataReport: "/physical/seal/dataReport", // 物理状态统计
    physical_seal_deviceList: "/physical/seal/deviceList", // 智能章桶列表
    physical_seal_unBundling: "/physical/seal/unBundling", // 解绑
    physical_seal_update: "/physical/seal/update", // 修改物理印章
    physical_seal_delete: "/physical/seal/delete", // 删除物理印章
    physical_seal_deptTreeList: "/physical/seal/carved/deptTreeList", // 组织树
    physical_seal_physicalSealOptions: "/physical/seal/physicalSealOptions", // 申请用章-印章列表

    // 移交记录
    transfer_record_deptTreeList: "/signet/transfer/record/deptTreeList", // 组织树
    transfer_record_createApplication: "/signet/transfer/record/createApplication", // 创建移交申请
    transfer_record_toBeHandedOverDeviceList: "/signet/transfer/record/toBeHandedOverDeviceList", // 智能章桶列表
    transfer_record_flowList: "/signet/transfer/record/flowList", // 流程列表
    transfer_record_flowCategoryList: "/signet/transfer/record/flowCategoryList", // 流程分类列表
    transfer_record_approvalStatusList: "/signet/transfer/record/approvalStatusList", // 审批状态列表
    transfer_record_userList: "/signet/transfer/record/userList", // 用户列表

    // 换章申请
    change_seal_createApplication: "/physical/seal/change/createApplication", // 创建换章申请
    change_seal_deptTreeList: "/physical/seal/change/deptTreeList", // 组织树列表
    change_seal_toBeHandedOverDeviceList: "/physical/seal/change/toBeHandedOverDeviceList", // 章桶列表
    change_seal_physicalSealList: "/physical/seal/change/physicalSealList", // 物理印章列表
    change_seal_approvalStatusList: "/physical/seal/change/approvalStatusList", // 审批状态列表
    change_seal_flowList: "/physical/seal/change/flowList", // 审批流程列表
    change_seal_userList: "/physical/seal/change/userList", // 用户列表

    // 变更申请
    update_seal_approvalStatusList: "/physical/seal/update/approvalStatusList", // 审批状态列表
    update_seal_createApplication: "/physical/seal/update/createApplication", // 创建变更申请
    update_seal_deptTreeList: "/physical/seal/update/deptTreeList", // 组织树列表
    update_seal_flowList: "/physical/seal/update/flowList", // 审批流程列表
    update_seal_list: "/physical/seal/update/list", // 变更申请列表
    update_seal_physicalSealList: "/physical/seal/update/physicalSealList", // 物理印章列表
    update_seal_statusList: "/physical/seal/update/statusList", // 变更状态列表
    update_seal_userList: "/physical/seal/update/userList", // 用户列表

    cmy_physical_seal_update_deptTreeList: "/physical/seal/update/deptTreeList", //组织树列表
    cmy_physical_seal_change_deptTreeList: "/physical/seal/change/deptTreeList", //组织树列表
    cmy_signet_transfer_record_deptTreeList: "/signet/transfer/record/deptTreeList", //组织树列表
    cmy_physical_seal_carved_deptTreeList: "/physical/seal/carved/deptTreeList", //组织树列表

    //长江设计集团
    third_jumpLink_noAuthority_findApplicationIds: "/third/jumpLink/noAuthority/findApplicationIds", //申请单简单信息列表
    third_jumpLink_noAuthority_findApplicationInfo: "/third/jumpLink/noAuthority/findApplicationInfo", //申请单详细信息列表
    third_jumpLink_noAuthority_findRecordInfos: "/third/jumpLink/noAuthority/findRecordInfos", //使用记录列表

    // 装章记录
    install_seal_list: "/device/installSealVideoMerge/findList",
    install_seal_getInfoByFileId: "/deviceManager/getInfoByFileId", // 文件为图片时参数 fileId
    install_seal_getVideoInfo: "/device/sealRecordVideoTs/hls", // 文件为视频

    // 控件管理
    controlManage_list: "/form/settings/list", // 控件管理列表
    controlManage_createControl: "/form/settings/createForm", // 新增控件 参数： formCode, formType
    controlManage_createControlName: "/form/settings/createFormName", // 新增控件别名 参数： formId, formName
    controlManage_updateControl: "/form/settings/updateForm", // 更新控件 参数：formId,formCode, formType
    controlManage_updateControlName: "/form/settings/updateFormName", // 更新控件别名 参数：formNameId, formName
    controlManage_deleteControl: "/form/settings/deleteForm", // 删除控件 参数：formId
    controlManage_deleteControlName: "/form/settings/deleteFormName", // 删除控件别名 参数：formNameId
	
	// 申请装章
	application_application_createForYanshi: "/application/application/createForYanshi", // 申请装章
	device_signet_installationChapterHeadForYanShi: "/device/signet/installationChapterHeadForYanShi", // 装章
	// 实物印章用印
	physical_seal_recordInfo_create: "/physical/seal/recordInfo/create", // 添加用印记录
	physical_seal_recordInfo_list: "/physical/seal/recordInfo/list", // 根据申请单ID查询列表数据
	
};
export default api



// WEBPACK FOOTER //
// ./src/api/lz_api.js